// Lib
import React from 'react';

import packageFile from '../../../package.json';

// Styles
import { useStyles } from './VersionStyles';

const Version = () => {
  const { classes } = useStyles();

  return (
    <div
      className={
        classes.root
      }>{`Frontend version: ${packageFile.version}`}</div>
  );
};

export default Version;
